import { forOwn } from 'lodash-es';
import { Reducer } from 'store';
import {
    IFranfinanceEntities,
} from 'services/ApiService';

export const initialState = {
    franFinance: {} as IFranfinanceEntities,
} as const;

export type NormalizrState = typeof initialState;

export const NormalizrReducer: Reducer<NormalizrState> = (state = initialState, action) => {
    let newState: any;
    switch (action.type) {
        case '@NORMALIZR/MERGE_FRANFINANCE_ENTITIES':
            newState = mergeEntities(state.franFinance, action.payload);
            return {
                ...state,
                franFinance: newState,
            };

        case '@NORMALIZR/REMOVE_FRANFINANCE_ENTITIES':
            newState = removeEntities(state.franFinance, action.payload);
            return {
                ...state,
                franFinance: newState,
            };




        default:
            return state;
    }
};

type Entities = IFranfinanceEntities;

const removeEntities = (entities: Entities, payload: Entities) => {
    const newState = createNewState(entities);

    forOwn(payload, (value, key) => {
        if (newState[key]) {
            forOwn(value, (_, entityKey) => {
                if (entityKey in newState[key]) {
                    delete newState[key][entityKey];
                }
            });
        }
    });
    return newState;
};

const mergeEntities = (entities: Entities, payload: Entities) => {
    const newState = createNewState(entities);

    forOwn(payload, (value, key) => {
        if (newState[key]) {
            forOwn(value, (entity, entityKey) => {
                newState[key][entityKey] = entity;
            });
        }
        else {
            newState[key] = {
                ...value,
            };
        }
    });
    return newState;
};

const createNewState = (state: Entities) => {
    const newState: any = {};
    forOwn(state, (value, key) => {
        newState[key] = {
            ...value,
        };
    });
    return newState;
};
